jQuery ($) ->
	days = []
	hours = {}
	hoursData = []
	$form = $('.contours-lead-form')
	branchSelector = 'select[name=branch]'
	dateSelector = 'select[name=date]'
	hourSelector = 'select[name=hour]'
	statusClass = 'contours-lead-form__pair__wrapper__status'
	statusClassValid = "#{statusClass}--valid"
	statusClassInvalid = "#{statusClass}--invalid"
	occupiedHoursIds = $.parseJSON($form.attr('data-hours')) or []
	errorClass = "#{statusClass}__error"
	fields =
		firstName: $('[name=firstName]', $form)
		lastName: $('[name=lastName]', $form)
		phone: $('[name=phone]', $form)
		email: $('[name=email]', $form)
		branch: $('[name=branch]', $form)
		date: $('[name=date]', $form)
		hour: $('[name=hour]', $form)
		agree: $('[name=agree]', $form)

	$('.contours-lead-form__pair__link').colorbox?(
		inline: true
		href: '#contours-lead-terms'
		closeButton: true
	)

	$('.contours-lead-form__pair__link2').colorbox?(
		inline: true
		href: '#contours-lead-terms2'
		closeButton: true
	)

	padWithZero = (number) ->
		if number < 10
			"0#{number}"
		else
			number

	dateFromString = (str) ->
		a = $.map str.split(/[^0-9]/), (s) ->
			parseInt(s, 10)
		new Date(
			a[0]
			a[1]-1 or 0
			a[2] or 1
			a[3] or 0
			a[4] or 0
			a[5] or 0
			a[6] or 0
		)

	splitDate = (date) ->
		[
			date.getFullYear()
			padWithZero(date.getMonth() + 1)
			padWithZero(date.getDate())
		]

	formatDateForRequest = (date) ->
		[_year, _month, _day] = splitDate(date)
		"#{_year}-#{_month}-#{_day}"

	formatDateForDisplay = (date) ->
		[_year, _month, _day] = splitDate(date)
		"#{_day}.#{_month}.#{_year}"

	formatTimeForDisplay = (date) ->
		_hours = padWithZero(date.getHours())
		_minutes = padWithZero(date.getMinutes())
		"#{_hours}:#{_minutes}"

	updateDummy = (name) ->
		$field = fields[name]
		$option = $('option:selected', $field)
		$readonly = $field.prev('[readonly=readonly]')
		$readonly.val($option.text())

	dateSource = (req, res) ->
		days = []
		hours = {}
		branch = parseInt(req?.branch, 10)
		begin = new Date()
		end = new Date()
		end.setDate(begin.getDate() + 10)

		url = $form.attr('data-proxy') + '?' + $.param
			actionMod: 'RPC'
			displayMod: 'RPC'
			action: 'api'
			method: 'freeHours'
			office_id: branch
			begin: formatDateForRequest(begin)
			end: formatDateForRequest(end)

		if isNaN(branch)
			return

		$.getJSON url, (data) ->
			hoursData = []

			for i in data when i.start? and i.length?
				id = parseInt(i.id, 10)
				start = dateFromString(i.start)
				length = parseInt(i.length, 10)

				if start and not isNaN(length) and not isNaN(id)
					if id in occupiedHoursIds
						continue
					hoursData.push
						id: id
						start: start
						end: new Date(start.getTime() + length * 60000)

			hoursData.sort (a, b) ->
				a.start - b.start

			for h in hoursData
				date = formatDateForDisplay(h.start)

				if not hours[date]?
					hours[date] = []
					today = new Date()
					tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000)
					dateWithDay = date
					if today.toDateString() is h.start.toDateString()
						dateWithDay += ' - dnes'
					else if tomorrow.toDateString() is h.start.toDateString()
						dateWithDay += ' - zítra'
					else
						dayNames = [
							'neděle'
							'pondělí'
							'úterý'
							'středa'
							'čtvrtek'
							'pátek'
							'sobota'
						]
						dateWithDay += ' - ' + dayNames[h.start.getDay()]
					days.push(value: date, label: dateWithDay)

				hours[date].push
					id: h.id
					start: formatTimeForDisplay(h.start)
					end: formatTimeForDisplay(h.end)

			items = []
			if days.length > 0
				items.push(label: 'Vyberte datum')
			else
				items.push(label: 'Žádné termíny')

			for day in days
				items.push
					value: day.value
					label: day.label

			res(items)
			updateDummy('date')

	hourSource = (req, res) ->
		_hours = hours[req?.date]

		if not _hours or _hours.length == 0
			res(label: 'Žádné termíny')
			updateDummy('hour')
			return

		items = []
		items.push(label: 'Vyberte čas')

		for h in _hours
			items.push
				value: h.id
				label: "#{h.start}&ndash;#{h.end}"

		res(items)
		updateDummy('hour')

	$form.cascadingDropdown
		selectBoxes: [
			{
				selector: branchSelector
			}
			{
				selector: dateSelector
				requires: [branchSelector]
				source: dateSource
			}
			{
				selector: hourSelector
				requires: [dateSelector]
				source: hourSource
			}
		]
		onChange: (event, values) ->
			for name, value of values
				updateDummy(name)

	$form.submit ->
		resetErrors()
		url = $form.attr('data-action')
		loadingClass = 'contours-lead-form--loading'

		$form.addClass(loadingClass)

		data = {}
		for i in $form.serializeArray()
			if (value = processField(i.name, i.value)) isnt null
				data[i.name] = value

		$.post url, data, (errors) ->
			$form.removeClass(loadingClass)
			if (k for own k of errors).length is 0
				window.location.href = $form.attr('data-thank-you');
			else
				displayErrors(errors)

		return false

	processField = (name, value) ->
		switch name
			when 'lastName', 'firstName', 'phone', 'email', 'branch', 'agree'
				return value
			when 'hour'
				value = parseInt(value, 10)
				for h in hoursData
					if h.id is value
						return {
							id: h.id
							start: h.start.getTime() / 1000
							end: h.end.getTime() / 1000
						}
				return null
			else
				return null

	resetStatus = (name) ->
		$status = fields[name].nextAll(".#{statusClass}")
		$status.removeClass(statusClassValid)
		$status.removeClass(statusClassInvalid)
		$(".#{errorClass}", $status).fadeOut()

	resetErrors = ->
		for name, $field of fields
			resetStatus(name)

	displayErrors = (errors) ->
		for name, $field of fields
			$status = $field.nextAll(".#{statusClass}")

			if name of errors
				$status.addClass(statusClassInvalid)
				$(".#{errorClass}--#{errors[name]}", $status).fadeIn()
			else
				$status.addClass(statusClassValid)

			$field.one 'change paste keyup', do (n = name) ->->
				resetStatus(n)
				resetStatus('hour') if n is 'date'
				resetStatus('date') if n is 'hour'
